/* Presentation only. Every purchase uses the existing native product form and EGO. */
(() => {
  const form = document.getElementById('disc-product-form');
  const input = form?.querySelector('[name="quantity"]');
  const data = document.getElementById('b2-offer-data');
  if (!form || !input || !data) return;
  const offer = JSON.parse(data.textContent);
  function update() {
    const quantity = Math.max(1, Math.min(10, Math.floor(Number(input.value) || 1)));
    input.value = String(quantity);
    document.querySelectorAll('[data-total]').forEach(el => { el.innerHTML = offer.prices[quantity - 1]; });
    document.querySelectorAll('[data-regular]').forEach(el => { el.innerHTML = offer.regular[quantity - 1]; });
    document.querySelectorAll('[data-quantity]:not(input)').forEach(el => { el.textContent = String(quantity); });
    document.querySelectorAll('[data-bundle-word]').forEach(el => { el.textContent = quantity === 1 ? offer.bundle : offer.bundles; });
    document.querySelector('[data-qty="minus"]').disabled = quantity === 1;
    document.querySelector('[data-qty="plus"]').disabled = quantity === 10;
  }
  input.addEventListener('change', update);
  document.querySelectorAll('[data-qty]').forEach(button => button.addEventListener('click', () => {
    input.value = String(Number(input.value) + (button.dataset.qty === 'plus' ? 1 : -1));
    update();
  }));
  document.getElementById('b2-country')?.addEventListener('change', event => event.target.form.requestSubmit());
  document.querySelectorAll('a[href="#voucher-question"]').forEach(link => link.addEventListener('click', () => { document.getElementById('voucher-question').open = true; }));
  document.querySelectorAll('a[href="#b2-loox"]').forEach(link => link.addEventListener('click', () => { document.getElementById('b2-loox').open = true; }));
  const videos = [...document.querySelectorAll('video')];
  videos.forEach(video => video.addEventListener('play', () => { videos.forEach(other => { if (other !== video) other.pause(); }); }));
  document.addEventListener('visibilitychange', () => { if (document.hidden) videos.forEach(video => video.pause()); });
  const sticky = document.querySelector('.sticky-buy');
  const visible = new Set();
  if (sticky && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
      sticky.hidden = visible.size > 0;
    }, { threshold: .5 });
    document.querySelectorAll('.hero-offer [data-b2-add], .mid-purchase [data-b2-add], .final-purchase [data-b2-add]').forEach(button => observer.observe(button));
  }
  window.addEventListener('pageshow', update);
  update();
})();
